import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'admin-page',
    loadChildren: () => import('./views/admin-page/admin-page.module').then(m => m.AdminPageModule),
  },
  {
    path: 'mass-upload',
    loadChildren: () => import('./views/mass-upload/mass-upload.module').then(m => m.MassUploadModule),
  },
  {
    path: 'plots',
    loadChildren: () => import('./views/plots/plots.module').then(m => m.PlotsModule),
  },
  {
    path: 'plot',
    loadChildren: () => import('./views/plots/plots.module').then(m => m.PlotsModule),
  },
  {
    path: 'devices',
    loadChildren: () => import('./views/devices/devices.module').then(m => m.DevicesModule),
  },
  {
    path: 'device-single',
    loadChildren: () => import('./views/devices/devices.module').then(m => m.DevicesModule),
  },
  {
    path: 'weather-stations',
    loadChildren: () => import('./views/meteo/meteo.module').then(m => m.MeteoModule),
  },
  {
    path: 'station-single',
    loadChildren: () => import('./views/meteo/meteo.module').then(m => m.MeteoModule),
  },
  {
    path: 'opekepe/login',
    loadChildren: () => import('./opekepe-login/opekepe-login.module').then(m => m.OpekepeLoginModule),
  },
  {
    path: 'tips',
    loadChildren: () => import('./views/tips/tips.module').then(m => m.TipsModule),
  },

  ...(!environment.uruguayFeatures ? [
    {
      path: 'history',
      loadChildren: () => import('./views/history/history.module').then(m => m.HistoryModule),
    },
    {
      path: 'statistics',
      loadChildren: () => import('./views/statistics/statistics.module').then(m => m.StatisticsModule),
    },
    {
      path: 'management',
      loadChildren: () => import('./views/management/management.module').then(m => m.ManagementModule),
    },
    {
      path: 'pests',
      loadChildren: () => import('./views/pests/pests.module').then(m => m.PestsModule),
    },
    {
      path: 'carbon-footprint',
      loadChildren: () => import('./views/carbon-footprint/carbon-footprint.module').then(m => m.CarbonFootprintModule),
    },
    {
      path: 'upload',
      loadChildren: () => import('./views/upload/upload.module').then(m => m.UploadModule),
    },
    {
      path: 'storage',
      loadChildren: () => import('./views/storage/storage.module').then(m => m.StorageModule),
    },
    {
      path: 'reports',
      loadChildren: () => import('./views/reports/reports.module').then(m => m.ReportsModule),
    },
    {
      path: 'multimanagement',
      loadChildren: () => import('./views/multimanagement/multimanagement.module').then(m => m.MultimanagementModule),
    },
    {
      path: 'mass-export',
      loadChildren: () => import('./views/mass-export/mass-export.module').then(m => m.MassExportModule),
    },
    {
      path: 'contact-us',
      loadChildren: () => import('./views/contact-us/contact-us.module').then(m => m.ContactUsModule),
    },
  ] : []),

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
